import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useTranslator } from 'tradera-lang';
import {
    useBreakpoint,
    BREAKPOINTS
} from 'tradera-components/breakpoint/breakpoint';
import GdprSettings from 'tradera-utils/gdpr-settings';
import AppleLoginButton from 'areas/Login/static/script/app/ui/apple-login-button';
import ErrorIcon from '@tradera/blueprint/theme/icons2/alert.svg?jsx';
import FacebookLoginButton from 'areas/Login/static/script/app/ui/facebook-login-button';
import GoogleLoginButton from 'areas/Login/static/script/app/ui/google-login-button';
import InfoIcon from '@tradera/blueprint/theme/icons2/info.svg?jsx';

const SocialLogins = props => {
    const {
        appleClientId,
        facebookAppId,
        className,
        googleAppId,
        isModal,
        tabIndexStart
    } = props;
    const cookiesEnabled = GdprSettings.isFunctionalEnabled();
    const isAnySocialLoginEnabled = appleClientId || facebookAppId;
    const [error, setError] = useState(null);
    const { t } = useTranslator();
    const currentBreakpoint = useBreakpoint();
    const isMobile = [BREAKPOINTS.XS, BREAKPOINTS.SM].includes(
        currentBreakpoint
    );
    if (isAnySocialLoginEnabled) {
        return (
            <div className={className}>
                <p>{t('login_useSocialLogin')}</p>
                {!cookiesEnabled && (
                    <div className="alert alert-danger text-left mb-3">
                        <h4 className="text-white">
                            <InfoIcon className="icon icon-lg align-text-bottom mr-2" />
                            &nbsp;
                            {t('login_cookieMissingWarningTitle')}
                        </h4>
                        <p className="mb-0">
                            {t('login_cookieMissingWarning')}
                        </p>
                    </div>
                )}
                <div className="mx-n2 d-flex d-sm-block justify-content-around">
                    {googleAppId && (
                        <GoogleLoginButton
                            googleAppId={googleAppId}
                            className="m-2"
                            compact={isMobile}
                            disabled={!cookiesEnabled}
                            onError={error => setError(error)}
                            tabIndex={tabIndexStart + 1}
                        />
                    )}
                    {facebookAppId && (
                        <FacebookLoginButton
                            className="m-2 mr-md-0"
                            compact={isMobile}
                            disabled={!cookiesEnabled}
                            facebookAppId={facebookAppId}
                            isModal={isModal}
                            onError={error => setError(error)}
                            tabIndex={tabIndexStart}
                        />
                    )}
                    {appleClientId && (
                        <AppleLoginButton
                            appleClientId={appleClientId}
                            className="m-2"
                            compact={isMobile}
                            disabled={!cookiesEnabled}
                            onError={error => setError(error)}
                            tabIndex={tabIndexStart + 1}
                        />
                    )}
                </div>
                {error && (
                    <div className="alert alert-danger text-left my-2">
                        <p className="mb-0">
                            <ErrorIcon className="icon align-text-bottom" />
                            &nbsp;{t('login_error')}
                        </p>
                    </div>
                )}
                <p className="mt-4 mb-0">{t('login_orEnter')}</p>
            </div>
        );
    } else {
        return null;
    }
};

SocialLogins.propTypes = {
    appleClientId: PropTypes.string,
    facebookAppId: PropTypes.string,
    googleAppId: PropTypes.string,
    className: PropTypes.string,
    isModal: PropTypes.bool,
    tabIndexStart: PropTypes.number
};

SocialLogins.defaultProps = {
    className: '',
    tabIndexStart: 0
};

export default SocialLogins;
